import { render, staticRenderFns } from "./timeHorizon.vue?vue&type=template&id=3782738c&scoped=true&"
import script from "./timeHorizon.vue?vue&type=script&lang=js&"
export * from "./timeHorizon.vue?vue&type=script&lang=js&"
import style0 from "./timeHorizon.vue?vue&type=style&index=0&id=3782738c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3782738c",
  null
  
)

export default component.exports